// extracted by mini-css-extract-plugin
export default {"btn":"Btn_btn__SoHZL","btn--shadow":"Btn_btn--shadow__ga+9D","btn--black":"Btn_btn--black__T89NG","btnRipple":"Btn_btnRipple__krsDV","ripple":"Btn_ripple__S3x35"};